<template>
  <v-sheet>
    <v-btn
      :disabled="disableBookmarkButton"
      icon
      @click.stop="toggleBookmarkCurrentRoute"
    >
      <v-icon
        icon
      >
        {{ bookmarkIcon }}
      </v-icon>
    </v-btn>

    <bookmark-modals v-if="!disableBookmarkButton" />
  </v-sheet>
</template>

<script>
import BookmarkMixin from 'src/tools/store/utils/bookmarks-mixin'

export default {
  name: 'BookmarkIcon',
  components: {
    BookmarkModals: () => import('src/bookmark/components/BookmarkModals'),
  },
  mixins: [
    BookmarkMixin,
  ],
  computed: {
    disableBookmarkButton() {
      return !this.selectedSearch
        || !this.routeName
        || ['docs', 'home'].indexOf(this.routeName) !== -1
        || !this.reportPath
        || !this.associationId
        || (this.associationId === 'all-associations' && this.routeName !== 'internal')
    },
  },
}
</script>
